import { render, staticRenderFns } from "./DashInventoryDeadlines.vue?vue&type=template&id=97e0860e&scoped=true&"
import script from "./DashInventoryDeadlines.vue?vue&type=script&lang=js&"
export * from "./DashInventoryDeadlines.vue?vue&type=script&lang=js&"
import style0 from "./DashInventoryDeadlines.vue?vue&type=style&index=0&id=97e0860e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e0860e",
  null
  
)

export default component.exports